module.exports = __webpack_public_path__ + "img/HIES.5e007f5b.png";